export default{

    addPlaceholder: 'Add this as new tag',
    chartTags: 'Chart Tags',
}